import { render, staticRenderFns } from "./qyjygl.vue?vue&type=template&id=251966c0&scoped=true"
import script from "./qyjygl.vue?vue&type=script&lang=js"
export * from "./qyjygl.vue?vue&type=script&lang=js"
import style0 from "./qyjygl.vue?vue&type=style&index=0&id=251966c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251966c0",
  null
  
)

export default component.exports